export var OpenIdIdentityIssuerType;
(function (OpenIdIdentityIssuerType) {
    OpenIdIdentityIssuerType["GOOGLE"] = "google";
    OpenIdIdentityIssuerType["OKTA"] = "okta";
    OpenIdIdentityIssuerType["ONELOGIN"] = "oneLogin";
    OpenIdIdentityIssuerType["AZUREAD"] = "azuread";
    OpenIdIdentityIssuerType["GENERIC_OIDC"] = "oidc";
    OpenIdIdentityIssuerType["SNOWFLAKE"] = "snowflake";
})(OpenIdIdentityIssuerType || (OpenIdIdentityIssuerType = {}));
export const isOpenIdIdentityIssuerType = (value) => Object.values(OpenIdIdentityIssuerType).includes(value);
//# sourceMappingURL=openIdIdentity.js.map